import React from "react";

function Logo() {
  return (
    <div className=" w-full h-full">
      <img
        className=" object-contain w-full h-full"
        alt=""
        src="https://res.cloudinary.com/nuirai/image/upload/v1647704591/passage/passage-min_itjcia.png"
      />
    </div>
  );
}

export default Logo;
